import {Button, CircularProgress, Dialog, DialogContent, TextField, Tooltip, useMediaQuery} from "@mui/material";
import './styless.scss'
import CloseIcon from "@mui/icons-material/Close";
import {ContactIcon, CorrectIcon, Email, WechatIcon, WechatLargeIcon, AlipayIcon} from "../../icons";
import droplet from "../../assets/droplet.png"
import {Trans, useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {
    createOrderApi,
    createWechatMembershipRenew,
    getQrcode,
    getRechargeRecords,
    getRecords,
    sendGiftCode,
    createAlipayMembershipRenew,
    createAlipayPage,
    queryAlipayOrder,
    createProductOrder, getProductRechargeRecords, createAlipayForProductPage,
    getPointsDetail,
    getMembershipQueue,
    MembershipQueueItem,
    MembershipQueueResponse,
    PointsDetailItem
} from "../../api/payment";
import {getLocalStorage} from "../../util/storage";
import {LoginProps} from "../../types/authority";
import {useDispatch, useSelector} from "react-redux";
import {
    fetchMemberInfoAsync,
    setGlobalDialogTips,
    setOpenMemberBillDialogChange,
    setOpenDropDialogChange,
    setOpenWaterShortage, setOpenWaterShortage2, setDropActiveDialogOpen
} from "../../store/memberSlice";
import {AppDispatch, RootState} from "../../store";
import {fetchWaterdropProductsAsync} from "../../store/waterdropSlice";
import {notificationService} from "../../services/notification";
import {setSnackbarOpen} from "../../store/taskSlice";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import dropBanner from '../../assets/dropBanner.png'
import WaterDropBag from "./waterDropBag";
import AlipayLogo from '../../assets/alipayLogo.png'
import NewYears from '../../assets/newYears.png'
import PaymentRules from "./paymentRules";
import Bill from "./bill";
import DropWaterDetailSidebar from "./dropWaterDetailSidebar";
import ExistingMembershipDialog from "./ExistingMembershipDialog";
import PaymentMainDialog from "./PaymentMainDialog";
import DropWaterDetailDialog from "./DropWaterDetailDialog";
import {usePendingTaskPoller} from "../../hooks/usePendingTask";
const POINTS_TYPE_LABEL: Record<string, string> = {
    flowing_water: '免费水滴',
    member_drops: '会员水滴',
    other_drops: '其他水滴',
    supply_drop: '补给水滴',
};

function formatPointsDetailDate(isoDate: string): string {
    try {
        const d = new Date(isoDate);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day} ${h}:${min}`;
    } catch {
        return isoDate;
    }
}

function getPointsDetailDescriptionLabel(description: string): string {
    if (!description) return description;
    if (description.includes('消费支付: 生图')) return '图片生成';
    if (description.includes('消费支付: tokens')) return '文本生成';
    return description;
}

export default function Payment (props: {labelDialogOpen: boolean, handleSetLabelDialogClose: ()=>void}) {
    const {labelDialogOpen, handleSetLabelDialogClose} = props;

    const {
        trackSubscriptionPlanPopupConfirm,
        trackQrcodeShowStatus,
        trackWaterdropPackagePopupShow,
        trackInvoiceEntryClick,
    } = useMatomoTrackingPoint()

    const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
    const [checkBoxDialogOpen, setCheckBoxDialogOpen] = useState(false);

    const [giftCode, setGiftCode] = useState('');

    const [RedeemMessage, setRedeemMessage] = useState('')

    const [callBackPlan, setCallBackPlan] = useState<{plan: string; amount: number; dropAmount: number; immediateEffect?: boolean; productId?: string}>({plan: '', amount: 0, dropAmount: 0})

    const [paymentDetail, setPaymentDetail] = useState({
        amount: 0,
        qrCode: ''
    })

    const paymentDialogOpenRef = useRef<number | null>(null);
    const labelDialogOpenRef = useRef<number | null>(null);
    const waterShortageDialogOpenRef = useRef<number | null>(null);
    const isClosedByGetWaterdropButtonRef = useRef<boolean>(false);

    const {trackBillingPopupShowTime, trackWaterdropPackagePopupShowTime, trackYearlySubscriptionPopupShow} = useMatomoTrackingPoint()

    const {trackGiftCodeRedeem, trackGiftCodeRedeemStatus, trackGetWaterdropClick, trackActivityPopupClick, trackBillingPopupShow, trackWaterdropLackPopupClose} = useMatomoTrackingPoint()

    const [paymentSuccess, setPaymentSuccess] = useState(false)

    const [membershipQueue, setMembershipQueue] = useState<MembershipQueueItem[]>([])
    const [membershipQueueRaw, setMembershipQueueRaw] = useState<MembershipQueueResponse['data'] | null>(null)

    const [openDropWaterDialog, setOpenDropWaterDialog] = useState(false)
    const [openBillDialog, setOpenBillDialog] = useState(false)
    const [pointsDetailList, setPointsDetailList] = useState<PointsDetailItem[]>([])
    const [pointsDetailLoading, setPointsDetailLoading] = useState(false)
    const [pointsDetailLoadingMore, setPointsDetailLoadingMore] = useState(false)
    const [pointsDetailPage, setPointsDetailPage] = useState(1)
    const [pointsDetailTotal, setPointsDetailTotal] = useState(0)
    const pointsDetailPageSize = 20

    const isMobile = useMediaQuery('(max-width: 768px)');

    const memberInfo = useSelector((state: RootState) => state.member.memberInfo);
    const dispatch: AppDispatch = useDispatch()

    const openDropDialog = useSelector((state: RootState) => state.member.openDropDialog);
    const openMemberBillDialog = useSelector((state: RootState) => state.member.openMemberBillDialog);

    const openWaterShortage = useSelector((state: RootState) => state.member.openWaterShortage);
    const openWaterShortage2 = useSelector((state: RootState) => state.member.openWaterShortage2);
    const openYearMemberDialog = useSelector((state: RootState) => state.member.openYearMemberDialog);

    const pollingRef = useRef<NodeJS.Timeout | null>(null);
    const alipayPollingRef = useRef<NodeJS.Timeout | null>(null);
    const [selectPaymentOpen, setSelectPaymentOpen] = useState(false);
    const [alipayHtml, setAlipayHtml] = useState('');
    const [alipayOutTradeNo, setAlipayOutTradeNo] = useState('');
    const [alipayIframeOpen, setAlipayIframeOpen] = useState(false);
    const alipayIframeRef = useRef<HTMLIFrameElement | null>(null);
    const [inlineQrVisible, setInlineQrVisible] = useState(false);
    const [inlineQrSrc, setInlineQrSrc] = useState('');
    const [inlineAmount, setInlineAmount] = useState(0);
    const [wechatPayLoading, setWechatPayLoading] = useState(false);
    const [wechatCountdown, setWechatCountdown] = useState(600);
    const alipayWindowRef = useRef<Window | null>(null);
    const [showAlipayInstruction, setShowAlipayInstruction] = useState(false);

    // 1是水滴 2是月会员
    const [packages, setPackages] = useState<number>(2);

    const { startPolling } = usePendingTaskPoller(() => {
        dispatch(fetchMemberInfoAsync());
    });

    const refreshMembershipQueue = useCallback(() => {
        getMembershipQueue().then((data: { queue: MembershipQueueItem[] } | null) => {
            if (data) {
                setMembershipQueueRaw(data);
                const tierOrder: Record<string, number> = {
                    max_year: 0, max: 1, pro_year: 2, pro: 3, plus_year: 4, plus: 5,
                };
                const sorted = data.queue
                    .filter(item => item.status === 'queued')
                    .sort((a, b) => (tierOrder[a.tier] ?? 99) - (tierOrder[b.tier] ?? 99));
                setMembershipQueue(sorted);
            }
        });
    }, []);

    const checkOrderStatus = async (out_trade_no: string) => {
        const response = await getRechargeRecords(out_trade_no);
        if (response?.records.length && (response.records[0].points_status === 'Success' || response.records[0].points_status === 'Queued')) {
            setPaymentSuccess(true)
            setPaymentDialogOpen(false)
            setSelectPaymentOpen(false) // 关闭选择支付对话框
            setShowAlipayInstruction(false) // 重置支付宝说明状态
            setInlineQrVisible(false) // 重置微信二维码状态
            closePaymentDialog()
        }
        if (response?.records.length && response.records[0].points_status === 'Failed') {
            setSelectPaymentOpen(false) // 关闭选择支付对话框
            setShowAlipayInstruction(false) // 重置支付宝说明状态
            setInlineQrVisible(false) // 重置微信二维码状态
            closePaymentDialog()
            dispatch(setSnackbarOpen({
                open: true,
                message: t('payment_failed')
            }));
        }
    };

    const checkOrderDropWaterStatus = async (out_trade_no: string) => {
        const response = await getProductRechargeRecords(out_trade_no);
        if (response?.points_status === 'Success' || response?.points_status === 'Queued') {
            setPaymentSuccess(true)
            setPaymentDialogOpen(false)
            setSelectPaymentOpen(false) // 关闭选择支付对话框
            setShowAlipayInstruction(false) // 重置支付宝说明状态
            setInlineQrVisible(false) // 重置微信二维码状态
            closePaymentDialog()
        }
        if (response?.points_status === 'Failed') {
            setSelectPaymentOpen(false) // 关闭选择支付对话框
            setShowAlipayInstruction(false) // 重置支付宝说明状态
            setInlineQrVisible(false) // 重置微信二维码状态
            closePaymentDialog()
            dispatch(setSnackbarOpen({
                open: true,
                message: t('payment_failed')
            }));
        }
    };

    const handleSelectPaymentOpen = (open: boolean) => {
        setSelectPaymentOpen(open)
    }

    const handleCallBackPlan = (plan: {plan: string, amount: number, dropAmount?: number, productId?: string}) => {
        setCallBackPlan({
            plan: plan.plan,
            amount: plan.amount,
            dropAmount: plan.dropAmount ?? 0,
            productId: plan.productId
        })
    }

    const checkAlipayStatus = async (out_trade_no: string) => {
        try {
            const res = await queryAlipayOrder(out_trade_no);
            if (res?.data?.trade_status === 'TRADE_SUCCESS') {
                setPaymentSuccess(true)
                setAlipayIframeOpen(false)
                setSelectPaymentOpen(false) // 关闭选择支付对话框
                setShowAlipayInstruction(false) // 重置支付宝说明状态
                setInlineQrVisible(false) // 重置微信二维码状态
                closePaymentDialog()
            }
            if (res?.data?.trade_status === 'TRADE_CLOSED' || res?.data?.trade_status === 'TRADE_FAILED') {
                setAlipayIframeOpen(false)
                setSelectPaymentOpen(false) // 关闭选择支付对话框
                setShowAlipayInstruction(false) // 重置支付宝说明状态
                setInlineQrVisible(false) // 重置微信二维码状态
                closePaymentDialog()
                dispatch(setSnackbarOpen({
                    open: true,
                    message: t('payment_failed')
                }));
            }
        } catch (e) {
            // ignore
        }
    };

    useEffect(() => {
        if (paymentDialogOpen) {
            paymentDialogOpenRef.current = Date.now();
        } else if (paymentDialogOpenRef.current) {
            const duration = Date.now() - paymentDialogOpenRef.current;
            const page_id = window.location.href;
            trackBillingPopupShowTime({show_time: duration, page_id})
            paymentDialogOpenRef.current = null;
        }
    }, [paymentDialogOpen]);

    const reportStayTime = (tab: number, recount?: boolean) => {
        if (labelDialogOpenRef.current) {
            const duration = Date.now() - labelDialogOpenRef.current;
            const page_id = window.location.href;
            if (tab === 1) {
                trackWaterdropPackagePopupShowTime({show_time: duration, page_id})
            }
            if (tab === 2) {
                trackBillingPopupShowTime({show_time: duration, page_id})
            }
            if (recount) {
                labelDialogOpenRef.current = Date.now();
            }else {
                labelDialogOpenRef.current = null;
            }
        }
    }

    useEffect(() => {
        if (labelDialogOpen) {
            labelDialogOpenRef.current = Date.now();
        }
    }, [labelDialogOpen]);

    useEffect(() => {
        if (openWaterShortage) {
            waterShortageDialogOpenRef.current = Date.now();
            isClosedByGetWaterdropButtonRef.current = false;
        } else if (waterShortageDialogOpenRef.current) {
            // 如果是通过点击"获取水滴"按钮关闭的，则不触发埋点
            if (!isClosedByGetWaterdropButtonRef.current) {
                const page_id = window.location.href;
                const queryParams = new URLSearchParams(window.location.search);
                const boardId = queryParams.get('boardId');
                const show_time = Date.now() - waterShortageDialogOpenRef.current;
                trackWaterdropLackPopupClose({
                    device_id: getLocalStorage('device_id') || undefined,
                    page_id,
                    board_id: boardId || undefined,
                    card_id: undefined,
                    show_time,
                });
            }
            waterShortageDialogOpenRef.current = null;
            isClosedByGetWaterdropButtonRef.current = false;
        }
    }, [openWaterShortage]);

    useEffect(() => {
        if (openDropDialog) {
            setPackages(1)
        }
    }, [openDropDialog]);

    useEffect(() => {
        if (openYearMemberDialog) {
            setPackages(3)
        }
    }, [openYearMemberDialog]);

    useEffect(() => {
        if (openMemberBillDialog) {
            setOpenBillDialog(true);
            dispatch(setOpenMemberBillDialogChange(false));
        }
    }, [openMemberBillDialog, dispatch]);

    useEffect(() => {
        if (!labelDialogOpen) {
            dispatch(setOpenDropDialogChange(false))
            setPackages(2)
        }
    }, [labelDialogOpen]);

    useEffect(() => {
        if (labelDialogOpen) {
            refreshMembershipQueue();
            dispatch(fetchWaterdropProductsAsync());
        }
    }, [labelDialogOpen]);

    useEffect(() => {
        if (alipayHtml && alipayIframeOpen && alipayIframeRef.current) {
            try {
                const iframeDoc = alipayIframeRef.current.contentWindow?.document;
                if (iframeDoc) {
                    iframeDoc.open();
                    iframeDoc.write(alipayHtml);
                    iframeDoc.close();
                }
            } catch (e) {
                // ignore cross-origin or write errors
            }
        }
    }, [alipayHtml, alipayIframeOpen]);

    const closePaymentDialog = () => {
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        if (alipayPollingRef.current) {
            clearInterval(alipayPollingRef.current);
            alipayPollingRef.current = null;
        }
        // 重置所有支付相关状态
        setSelectPaymentOpen(false);
        setShowAlipayInstruction(false);
        setInlineQrVisible(false);
        setPaymentDialogOpen(false);
        setAlipayIframeOpen(false);
    };

    useEffect(() => {
        if(!labelDialogOpen) closePaymentDialog()
        return () => {
            closePaymentDialog()
        };
    }, [labelDialogOpen]);

    // 当 selectPaymentOpen 变为 false 时，清理轮询
    useEffect(() => {
        if (!selectPaymentOpen) {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
            if (alipayPollingRef.current) {
                clearInterval(alipayPollingRef.current);
                alipayPollingRef.current = null;
            }
        }
    }, [selectPaymentOpen]);

    const { t } = useTranslation()

    const useInfoStr = getLocalStorage('userInfo');
    const localUserInfo = useInfoStr ? JSON.parse(useInfoStr) as LoginProps : null;

    useEffect(() => {
        dispatch(fetchMemberInfoAsync())
    }, [labelDialogOpen]);

    useEffect(() => {
        if (!openDropWaterDialog) return;
        setPointsDetailLoading(true);
        setPointsDetailPage(1);
        getPointsDetail(1, pointsDetailPageSize)
            .then((res) => {
                if (res?.data) {
                    setPointsDetailList(res.data.list);
                    setPointsDetailTotal(res.data.total);
                    setPointsDetailPage(res.data.page);
                } else {
                    setPointsDetailList([]);
                    setPointsDetailTotal(0);
                }
            })
            .finally(() => setPointsDetailLoading(false));
    }, [openDropWaterDialog]);

    const loadMorePointsDetail = useCallback(() => {
        if (pointsDetailLoadingMore || pointsDetailLoading) return;
        if (pointsDetailList.length >= pointsDetailTotal) return;
        const nextPage = pointsDetailPage + 1;
        setPointsDetailLoadingMore(true);
        getPointsDetail(nextPage, pointsDetailPageSize)
            .then((res) => {
                if (res?.data?.list?.length) {
                    setPointsDetailList((prev) => [...prev, ...res.data.list]);
                    setPointsDetailPage(res.data.page);
                }
            })
            .finally(() => setPointsDetailLoadingMore(false));
    }, [pointsDetailPage, pointsDetailTotal, pointsDetailList.length, pointsDetailLoadingMore, pointsDetailLoading]);


    useEffect(() => {
        if (!inlineQrVisible) return;

        setWechatCountdown(600);

        const timer = window.setInterval(() => {
            setWechatCountdown(prev => {
                if (prev <= 1) {
                    window.clearInterval(timer);
                    setInlineQrVisible(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            window.clearInterval(timer);
        };
    }, [inlineQrVisible]);

    const createOrder = (plan: string, amount: number) => {
        const now = new Date();
        const expireTime = new Date(now.getTime() + 3* 24 * 60 * 60 * 1000); // 3天
        const timeExpire = expireTime.toISOString().replace('Z', '+08:00');
        closePaymentDialog()
        createOrderApi(amount * 100, plan, timeExpire).then(res => {
            if (res.code === 200 && res.data?.qr_code) {
                getQrcode(res?.data.qr_code).then(item => {
                    if (item?.qrCode) {
                        setPaymentDetail({amount, qrCode: item?.qrCode})
                        setPaymentDialogOpen(true)
                        trackQrcodeShowStatus({subscription_plan: plan})
                        pollingRef.current = setInterval(()=>{
                            checkOrderStatus(res.data.out_trade_no).then()
                        }, 1000);
                    }
                })
            }else {
                dispatch(setSnackbarOpen({
                    open: true,
                    message: res.message
                }));
            }
        });
    }

    const createOrderInline = async (plan: string, amount: number, productId?: string) => {
        const now = new Date();
        const expireTime = new Date(now.getTime() + 15 * 60 * 1000); // 15min
        const timeExpire = expireTime.toISOString().replace('Z', '+08:00');

        const res = packages === 1 && productId ? await createProductOrder(productId, timeExpire) :
            await createOrderApi(amount * 100, plan, timeExpire, productId)

        if (res?.code === 200 && res.data?.qr_code) {
            const item = await getQrcode(res?.data.qr_code);
            if (item?.qrCode) {
                setInlineQrSrc(item.qrCode)
                setInlineAmount(amount)
                setInlineQrVisible(true)
                trackQrcodeShowStatus({subscription_plan: plan, switch_status: 'Wechat', switch_from: memberInfo?.membershipTier})
                pollingRef.current = setInterval(()=>{
                    if (packages === 1) {
                        checkOrderDropWaterStatus(res.data.out_trade_no).then()
                    }else {
                        checkOrderStatus(res.data.out_trade_no).then()
                    }
                }, 1000);
                return;
            }
            dispatch(setSnackbarOpen({
                open: true,
                message: t('payment_failed')
            }));
        }else {
            dispatch(setSnackbarOpen({
                open: true,
                message: res?.message || ''
            }));
        }
    }
    const handleWechatPay = async () => {
        if (wechatPayLoading || inlineQrVisible) return;
        setWechatPayLoading(true);
        // show QR inline inside the selection dialog (no new dialog)
        const isMembershipRenew = packages !== 1
            && !!memberInfo?.membershipTier
            && callBackPlan.plan === memberInfo.membershipTier;

        if (!isMembershipRenew) {
            try {
                await createOrderInline(callBackPlan.plan, callBackPlan.amount, callBackPlan.productId);
            } finally {
                setWechatPayLoading(false);
            }
            return;
        }

        try {
            const res = await createWechatMembershipRenew(callBackPlan.productId, callBackPlan.immediateEffect);
            if (res.code === 200 && res.data?.qr_code) {
                const tier = res.data.tier || callBackPlan.plan;
                const amount = callBackPlan.amount;

                setCallBackPlan(prev => ({ ...prev, plan: tier, amount }));
                const item = await getQrcode(res.data.qr_code);
                if (item?.qrCode) {
                    setInlineQrSrc(item.qrCode)
                    setInlineAmount(amount)
                    setInlineQrVisible(true)
                    trackQrcodeShowStatus({ subscription_plan: tier })
                    pollingRef.current = setInterval(() => {
                        checkOrderStatus(res.data.out_trade_no).then()
                    }, 1000);
                } else {
                    dispatch(setSnackbarOpen({
                        open: true,
                        message: t('payment_failed')
                    }));
                }
            } else {
                dispatch(setSnackbarOpen({
                    open: true,
                    message: res.message || ''
                }));
            }
        } catch (e) {
            dispatch(setSnackbarOpen({
                open: true,
                message: t('payment_failed')
            }));
        } finally {
            setWechatPayLoading(false);
        }
    }

    const handleAlipayPay = async () => {
        setShowAlipayInstruction(true); // 显示支付宝说明
        // 切到支付宝即放弃微信这一单：停掉微信轮询并收起二维码
        // （只停轮询不收码的话，那张码会被 inlineQrVisible 守卫挡住重新下单，却再也没人查单）
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        setInlineQrVisible(false);
        try {
            const isMembershipRenew = packages !== 1
                && !!memberInfo?.membershipTier
                && callBackPlan.plan === memberInfo.membershipTier;

            const res = packages === 1
                ? await createAlipayForProductPage(callBackPlan.productId)
                : isMembershipRenew
                    ? await createAlipayMembershipRenew(callBackPlan.productId, callBackPlan.immediateEffect)
                    : await createAlipayPage(callBackPlan.productId, callBackPlan.plan);

            if (res?.code === 200 && res.data?.html) {
                trackQrcodeShowStatus({subscription_plan: callBackPlan.plan, switch_status: 'Alipay', switch_from: memberInfo?.membershipTier})
                setAlipayHtml(res.data.html);
                setAlipayOutTradeNo(res.data.out_trade_no || '');
                // Try to open a new window first - make it smaller
                const windowWidth = 400;
                const windowHeight = 600;
                const left = (window.screen.width - windowWidth) / 2;
                const top = (window.screen.height - windowHeight) / 2;
                const newWin = window.open('', '_blank', `width=${windowWidth},height=${windowHeight},left=${left},top=${top},scrollbars=yes,resizable=yes`);
                if (newWin) {
                    try {
                        newWin.document.open();
                        newWin.document.write(res.data.html || '');
                        newWin.document.close();
                        alipayWindowRef.current = newWin;
                    } catch (e) {
                        // fallback to iframe
                        setAlipayIframeOpen(true);
                    }
                } else {
                    // popup blocked, fallback to iframe
                    setAlipayIframeOpen(true);
                }
                // start polling alipay order status
                if (res.data.out_trade_no) {
                    alipayPollingRef.current = setInterval(()=> {
                        checkAlipayStatus(res.data.out_trade_no || '').then();
                    }, 1000);
                }
            } else {
                dispatch(setSnackbarOpen({
                    open: true,
                    message: res.message || t('payment_failed')
                }));
            }
        } catch (e) {
            dispatch(setSnackbarOpen({
                open: true,
                message: t('payment_failed')
            }));
        }
    }

    const redeemGiftCode = () => {
        trackGiftCodeRedeem({})
        if (localUserInfo) {
            sendGiftCode(giftCode).then(item => {
                if(item?.success) {
                    setGiftCode('');
                    trackGiftCodeRedeemStatus({credits_account: 0, redeem_status: 'success'})
                    startPolling()
                    /*                    dispatch(setGlobalDialogTips({
                                            type: 'success',
                                            title: '礼品码兑换成功！',
                                            content: `礼品码兑换成功，获得 ${item.rewardAmount} 水滴。`,
                                            buttonContent: '确认',
                                        }))*/
                }else {
                    trackGiftCodeRedeemStatus({credits_account: null, redeem_status: 'fail'})
                    dispatch(setGlobalDialogTips({
                        type: 'error',
                        title: '礼品码兑换失败',
                        content: item?.message ? t(item.message) : '',
                        buttonContent: '确认',
                    }))
                }
            })
        }
    }

    const tackingPoint = (package_show_from: string) => {
        const page_id = window.location.href;
        trackWaterdropPackagePopupShow({
            package_show_from,
            page_id
        });
    }


    return <div>
        <Dialog
            open={openWaterShortage2}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div style={{width: '460px', padding: '15px', boxSizing: 'border-box'}}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}><img width='16px' src={droplet} alt='' /> <span style={{color: 'var(--c-text-primary)', fontWeight: 'bold', fontSize: '18px'}}>&nbsp;水滴余额不足啦！</span></div>
                    </div>
                    <div style={{fontSize: '14px', color: 'var(--c-text-primary)', marginTop: '20px'}}>当前还有未领取的免费水滴，领取后可继续享受创作乐趣~</div>
                    <div style={{marginLeft: 'auto', cursor: 'pointer', color: 'var(--c-brand)', border: '1px solid var(--c-brand)', borderRadius: '20px', width: '103px', height: '32px', fontSize: '16px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px'}}
                         onClick={()=>{
                             isClosedByGetWaterdropButtonRef.current = true;
                             dispatch(setOpenWaterShortage2(false))
                             dispatch(setDropActiveDialogOpen(true))
                             trackActivityPopupClick({page_id: window.location.href, switch_from: '水滴余额不足'})
                             const page_id = window.location.href;
                             const queryParams = new URLSearchParams(window.location.search);
                             const boardId = queryParams.get('boardId');
                             trackGetWaterdropClick({
                                 device_id: getLocalStorage('device_id') || undefined,
                                 page_id,
                                 board_id: boardId || undefined,
                                 card_id: undefined,
                                 switch_from: ''
                             })
                         }}
                    >前往</div>
                </div>
            </DialogContent>
        </Dialog>
        <Dialog
            open={openWaterShortage}
            onClose={()=>{dispatch(setOpenWaterShortage(false))}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div style={{width: '460px', padding: '15px', boxSizing: 'border-box'}}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}><img width='16px' src={droplet} alt='' /> <span style={{color: 'var(--c-text-primary)', fontWeight: 'bold', fontSize: '18px'}}>&nbsp;水滴余额不足啦！</span></div>
                        <CloseIcon onClick={()=>{
                            dispatch(setOpenWaterShortage(false))
                        }}/>
                    </div>
                    <div style={{fontSize: '14px', color: 'var(--c-text-primary)', marginTop: '20px'}}>您的余额无法支持本次操作，可前往水滴详情页补充，或开通专属会员，解锁畅爽创作体验~</div>
                    <div style={{marginLeft: 'auto', cursor: 'pointer', color: 'var(--c-brand)', border: '1px solid var(--c-brand)', borderRadius: '20px', width: '103px', height: '32px', fontSize: '16px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px'}}
                         onClick={()=>{
                             isClosedByGetWaterdropButtonRef.current = true;
                             dispatch(setOpenWaterShortage(false))
                             dispatch(setOpenDropDialogChange(true))
                             setTimeout(()=>{
                                 setPackages(2)
                             })
                             const page_id = window.location.href;
                             const queryParams = new URLSearchParams(window.location.search);
                             const boardId = queryParams.get('boardId');
                             trackGetWaterdropClick({
                                 device_id: getLocalStorage('device_id') || undefined,
                                 page_id,
                                 board_id: boardId || undefined,
                                 card_id: undefined,
                             })
                             trackBillingPopupShow({billing_popup_from: 'waterdrop_lack_popup', board_id: boardId})
                         }}
                    >获取水滴</div>
                </div>
            </DialogContent>
        </Dialog>
        <Dialog
            open={openBillDialog}
            onClose={()=>{setOpenBillDialog(false)}}
            fullScreen={isMobile}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: isMobile ? '0' : '20px'
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <Bill onClose={() => setOpenBillDialog(false)} />
            </DialogContent>
        </Dialog>
        <DropWaterDetailDialog
            open={openDropWaterDialog}
            onClose={() => {
                setOpenDropWaterDialog(false)
            }}
            pointsDetailLoading={pointsDetailLoading}
            pointsDetailList={pointsDetailList}
            pointsDetailLoadingMore={pointsDetailLoadingMore}
            hasMore={pointsDetailList.length < pointsDetailTotal}
            onLoadMore={loadMorePointsDetail}
        />
        <Dialog
            open={paymentSuccess}
            onClose={() => {
                startPolling()
                setPaymentSuccess(false)
                refreshMembershipQueue()
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div className='check-box' style={{fontWeight: 500, padding: 20}}>
                    <p style={{width: '380px', textAlign: 'center'}}>
                        {t('payment_success_price', {amount: callBackPlan.amount})}
                    </p>
                    {
                        packages === 2 && (() => {
                            const immediateEffect = callBackPlan.immediateEffect;
                            if (immediateEffect === undefined) {
                                return <p style={{width: '380px', textAlign: 'center'}}>{t('payment_success_plan', {plan: callBackPlan.plan})}</p>;
                            }
                            const text = immediateEffect
                                ? `续购已立即生效，${callBackPlan.dropAmount} 会员水滴正在为您发放`
                                : `续购成功，新一期 ${callBackPlan.dropAmount} 会员水滴将于下期会员生效时发放`;
                            return <p style={{width: '380px', textAlign: 'center'}}>{text}</p>;
                        })()
                    }
                    <div style={{display: 'flex', gap: '16px', justifyContent: 'flex-end', marginTop: '20px'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                startPolling()
                                setPaymentSuccess(false)
                                refreshMembershipQueue()
                            }}
                            sx={{
                                minWidth: '100px',
                                textTransform: 'none',
                                fontWeight: 500
                            }}
                        >
                            {t('confirm')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
        <ExistingMembershipDialog
            open={checkBoxDialogOpen}
            isSameTier={
                !!memberInfo &&
                packages !== 1 &&
                !!callBackPlan.plan &&
                callBackPlan.plan === memberInfo.membershipTier
            }
            currentTier={memberInfo?.membershipTier}
            callBackPlan={callBackPlan}
            renewalQueueMonths={memberInfo?.renewalQueueMonths}
            membershipQueue={membershipQueue}
            onClose={() => {
                trackSubscriptionPlanPopupConfirm({
                    page_id: window.location.href,
                    switch_status: 'cancel'
                })
                setCheckBoxDialogOpen(false)
            }}
            onConfirm={(immediateEffect) => {
                const selectContent = immediateEffect === true ? '立即生效' : immediateEffect === false ? '到期生效' : '';
                trackSubscriptionPlanPopupConfirm({
                    page_id: window.location.href,
                    switch_status: 'confirm',
                    select_content: selectContent,
                })
                if (immediateEffect !== undefined) {
                    setCallBackPlan(prev => ({...prev, immediateEffect}))
                }
                setSelectPaymentOpen(true)
                setCheckBoxDialogOpen(false);
            }}
        />
        <Dialog
            open={paymentDialogOpen}
            onClose={() => {
                setPaymentDialogOpen(false)
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div className='payment-code'>
                    <div className='amount'>
                        <Trans i18nKey="scan_to_pay" values={{amount: paymentDetail.amount}}
                               components={{span: <span/>}}/>
                    </div>
                    <div className='qr-code'>
                        <img
                            width='100%'
                            src={paymentDetail.qrCode}
                            alt=''
                        />
                    </div>
                    <div className='qr-tips'>{t('wechat_payment_instruction')} <WechatIcon/></div>
                </div>
            </DialogContent>
        </Dialog>
        {/* Payment selection dialog: choose WeChat or Alipay */}
        <Dialog
            open={selectPaymentOpen}
            onClose={() => {
                setSelectPaymentOpen(false);
                setShowAlipayInstruction(false); // 重置状态
                setInlineQrVisible(false); // 重置微信二维码状态
            }}
            aria-labelledby="select-payment-dialog"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                {showAlipayInstruction ? (
                    <div style={{padding: 24, width: 520, textAlign: 'center'}}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 12,
                            marginBottom: 12
                        }}>
                            <img src={AlipayLogo} alt=''/>
                        </div>
                        <div style={{
                            marginTop: '10px',
                            fontSize: '16px',
                            color: 'var(--c-text-primary)',
                            fontWeight: 'bold'
                        }}>请在新打开的去支付宝窗口完成付款
                        </div>
                        <div style={{fontSize: '16px', color: 'var(--c-text-secondary)'}}>
                            如果无支付窗口弹出，请检查浏览器设置是否拦截窗口弹出，待支付完成后，点击“完成”按钮完成支付。
                        </div>
                        <div style={{display: 'flex', gap: 12, justifyContent: 'center', marginTop: 24}}>
                            {/* <Button
                                variant="outlined"
                                onClick={() => {
                                    setShowAlipayInstruction(false);
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    minWidth: '120px',
                                    border: '1px solid var(--c-text-secondary)',
                                    color: 'var(--c-text-primary)'
                                }}
                            >
                                取消
                            </Button>*/}
                            <Button
                                variant="contained"
                                onClick={()=>{
                                    /* if (alipayOutTradeNo) {
                                         checkAlipayStatus(alipayOutTradeNo).then();
                                     }*/
                                    setShowAlipayInstruction(false);

                                    if (alipayPollingRef.current) {
                                        clearInterval(alipayPollingRef.current);
                                        alipayPollingRef.current = null;
                                    }
                                    // 关闭通过 window.open 打开的支付宝支付窗口
                                    if (alipayWindowRef.current && !alipayWindowRef.current.closed) {
                                        alipayWindowRef.current.close();
                                        alipayWindowRef.current = null;
                                    }
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    minWidth: '120px',
                                    backgroundColor: 'var(--c-accent)'
                                }}
                            >
                                确认
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div style={{width: 520, textAlign: 'center'}}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: '24px',
                            padding: 16,
                        }}>
                            {t('payment')}
                            <span onClick={()=>{
                                setSelectPaymentOpen(false);
                                setShowAlipayInstruction(false); // 重置状态
                                setInlineQrVisible(false); // 重置微信二维码状态
                                setWechatPayLoading(false);
                            }}><CloseIcon fontSize='medium' /></span>
                        </div>
                        <div style={{backgroundColor: 'var(--c-bg-tertiary)', paddingBottom: '20px'}}>
                            <div style={{fontWeight: 600, paddingTop: 25, marginBottom: 20, fontSize: '16px',
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>{t('payment_amount')}: <span
                                style={{color: 'var(--c-violet-strong)', fontSize: '24px', marginLeft: '6px'}}>¥{callBackPlan.amount.toFixed(2)}</span></div>
                            <div style={{display: 'flex', gap: 24, justifyContent: 'center', alignItems: 'center', marginBottom: inlineQrVisible ? '25px' : 0}}>
                                <div>
                                    <div style={{
                                        cursor: 'pointer',
                                        width: 140,
                                        height: 140,
                                        borderRadius: 10,
                                        background: 'var(--c-bg)',
                                        boxShadow: '0 4px 8px var(--c-shadow-soft)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}>
                                        {
                                            inlineQrVisible ? (
                                                <div style={{width: 120, height: 120}}>
                                                    <img src={inlineQrSrc} alt="qr"
                                                         style={{width: '100%', height: '100%'}}/>
                                                </div>
                                            ) : (
                                                <div onClick={handleWechatPay} style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    height: "100%",
                                                    width: "100%",
                                                    justifyContent: "space-between",
                                                    cursor: wechatPayLoading ? 'not-allowed' : 'pointer',
                                                    pointerEvents: wechatPayLoading ? 'none' : 'auto',
                                                }}>
                                                    <div></div>
                                                    <div style={{width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                        {wechatPayLoading ? <CircularProgress size={32} /> : <WechatLargeIcon/>}
                                                    </div>
                                                    <div style={{
                                                        background: 'var(--c-wechat)',
                                                        color: 'var(--c-on-color)',
                                                        width: "100%",
                                                        height: '32px',
                                                        borderBottomRightRadius: '10px',
                                                        borderBottomLeftRadius: '10px',
                                                        fontSize: '16px',
                                                        lineHeight: '32px'
                                                    }}>微信二维码
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div style={{
                                        color: 'var(--c-text-primary)', fontSize: '14px',
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: '6px',
                                        visibility: 'hidden'
                                    }}>请微信扫码完成支付 <WechatIcon/></div>
                                    {
                                        inlineQrVisible && <div style={{
                                            color: 'var(--c-text-primary)', fontSize: '14px',
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            position: 'absolute',
                                            left: '60px',
                                            bottom: '50px'
                                        }}>
                                            <div style={{display: 'flex'}}>请在<span
                                                style={{color: 'var(--c-brand)'}}>{String(Math.floor(wechatCountdown / 60)).padStart(2, '0')}:{String(wechatCountdown % 60).padStart(2, '0')}</span>内使用微信扫码完成支付 <WechatIcon/>
                                            </div>
                                            <div style={{fontSize: '12px', color: 'var(--c-text-secondary)'}}>若扫码后提示订单已过期失效，
                                            </div>
                                            <div style={{fontSize: '12px', color: 'var(--c-text-secondary)'}}>请刷新网页重试（不会重复扣款）
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div>
                                    <div onClick={handleAlipayPay} style={{
                                        cursor: 'pointer',
                                        width: 140,
                                        height: 140,
                                        borderRadius: 10,
                                        background: 'var(--c-bg)',
                                        boxShadow: '0 4px 8px var(--c-shadow-soft)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                    }}>
                                        <div></div>
                                        <div style={{width: 80, height: 80}}><AlipayIcon/></div>
                                        <div style={{
                                            background: 'var(--c-accent)',
                                            color: 'var(--c-on-color)',
                                            width: "100%",
                                            height: '32px',
                                            borderBottomRightRadius: '10px',
                                            borderBottomLeftRadius: '10px',
                                            fontSize: '16px',
                                            lineHeight: '32px'
                                        }}>跳转支付宝
                                        </div>
                                    </div>
                                    <div style={{color: 'var(--c-text-primary)', fontSize: '14px', visibility: 'hidden', marginTop: '6px'}}>请支付宝完成支付</div>
                                </div>
                            </div>
                        </div>
                        <div style={{
                            backgroundColor: 'var(--c-bg-secondary)',
                            height: '40px',
                            lineHeight: '40px',
                            color: 'var(--c-text-secondary)',
                            fontSize: '14px'
                        }}>
                            本商品为虚拟数字产品，一经售出不支持退款，请您在购买前确认需求。
                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>

        {/* Alipay iframe dialog */}
        <Dialog
            open={alipayIframeOpen}
            onClose={() => {
                setAlipayIframeOpen(false)
                if (alipayPollingRef.current) {
                    clearInterval(alipayPollingRef.current);
                    alipayPollingRef.current = null;
                }
                if (alipayWindowRef.current && !alipayWindowRef.current.closed) {
                    alipayWindowRef.current.close();
                    alipayWindowRef.current = null;
                }
            }}
            aria-labelledby="alipay-iframe-dialog"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "12px",
                    width: 520
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div style={{padding: 16}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                            <AlipayIcon/>
                            <div style={{fontWeight: 600}}>{t('payment')}</div>
                        </div>
                        <div onClick={() => setAlipayIframeOpen(false)} style={{cursor: 'pointer'}}><CloseIcon/></div>
                    </div>
                    <div style={{marginTop: 12}}>
                        <iframe
                            ref={(el) => {
                                alipayIframeRef.current = el;
                            }}
                            title="alipay"
                            style={{width: '100%', height: 360, border: 'none', borderRadius: 8}}
                        />
                    </div>
                    <div style={{marginTop: 8, color: 'var(--c-text-tertiary)'}}>{t('alipay_instruction') || t('payment_terms_tip')}</div>
                    <div style={{display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 12}}>
                        <Button variant="outlined" onClick={()=>{
                            setAlipayIframeOpen(false)
                            if (alipayPollingRef.current) {
                                clearInterval(alipayPollingRef.current);
                                alipayPollingRef.current = null;
                            }
                            if (alipayWindowRef.current && !alipayWindowRef.current.closed) {
                                alipayWindowRef.current.close();
                                alipayWindowRef.current = null;
                            }
                        }}>{t('cancel')}</Button>
                        <Button variant="contained" onClick={()=>{
                            if (alipayOutTradeNo) {
                                checkAlipayStatus(alipayOutTradeNo).then()
                            }
                        }}>{t('complete')}</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
        <PaymentMainDialog
            open={labelDialogOpen}
            onClose={handleSetLabelDialogClose}
            reportStayTime={reportStayTime}
            packages={packages}
            setPackages={setPackages}
            setOpenBillDialog={setOpenBillDialog}
            setOpenDropWaterDialog={setOpenDropWaterDialog}
            setCallBackPlan={setCallBackPlan}
            setSelectPaymentOpen={setSelectPaymentOpen}
            setCheckBoxDialogOpen={setCheckBoxDialogOpen}
            handleSelectPaymentOpen={handleSelectPaymentOpen}
            handleCallBackPlan={handleCallBackPlan}
            giftCode={giftCode}
            setGiftCode={setGiftCode}
            redeemGiftCode={redeemGiftCode}
            RedeemMessage={RedeemMessage}
            membershipQueue={membershipQueue}
            membershipQueueRaw={membershipQueueRaw}
        />

    </div>
}